const isClassroom = (user: any) => {
  if (user?.roles?.includes('class')) {
    return true;
  }
  return false;
};

export default isClassroom;
